import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Box, Grid, LinearProgress, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Logo from '../../assets/images/Logo.svg';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import { createAccessory, resetAccessoryActionState, resetAccessoryState } from "../../store/actions";
import AdvertisementInfo from "./form/AccessoryAdvertisementInfo";
import AccessoryInfo from "./form/AccessoryInfo";
import Review from "./form/AccessoryReview";
import UploadMedia from "./form/AccessoryUploadMedia";
import AccessoryAssignSalesman from "./form/AccessoryAssignSalesman";


const AddAccessory = ({ leftSideBarType, layoutWidth, brandList, categoryList, subCategoryList, makeList, modelList, accessoryAdd, generalCommonCode, isDirectSeller, salesmanList, locationList }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const totalPage = 5;
    const [currentStep, setCurrentStep] = useState(1);
    const [formObj, setFormObj] = useState({ pricing: { max_loan_tenure: 84 } });
    const [agreement, setAgreement] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [draft, setDraft] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const steps = [
        { header: 'Fill in the basic details of your accessory product', buttonText: 'Advert Details' },
        { header: 'Define advertisement details', buttonText: 'Advert Details' },
        { header: 'Assign salesman', buttonText: 'Assign Salesman' },
        { header: 'Upload Media', buttonText: 'Upload Media' },
        { header: 'Review and confirm', buttonText: 'Preview & Publish' },
    ]

    useEffect(() => {
        dispatch(resetAccessoryState());
        setError({});
    }, [])

    useEffect(() => {
        if (accessoryAdd?.code === 'validate_success' || accessoryAdd?.code === 'success') {
            setIsLoading(false);
            handleNextPage();
            dispatch(resetAccessoryActionState());
            error && setError({});
            if (currentStep === totalPage && accessoryAdd?.code === 'success') {
                setNotification({
                    open: true,
                    msg: accessoryAdd?.message || 'Your accessory has been successfully added.',
                    type: 'success',
                });
                navigate("/accessories");
            }
        } else if (accessoryAdd?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: accessoryAdd?.message || 'There are some errors in your form. Please check again.',
                type: "error",
            });
            setError(accessoryAdd?.errors || {});
        }
    }, [accessoryAdd])

    const handleFormObjChange = (key, value) => {
        let tempObj = { ...formObj };
        tempObj[key] = value;
        setFormObj(tempObj);
    }

    const handleGoBack = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        } else if (currentStep === 1) {
            navigate('/accessories');
        }
    }

    const handleNextPage = () => {
        if (currentStep <= totalPage) {
            setCurrentStep(currentStep + 1);
        } else {

        }
    }


    const handleVerifyForm = () => {
        let payload = { step: currentStep }
        // setIsLoading(true);
        if (currentStep === 1 || currentStep === 5) {
            payload.brand_id = formObj?.brand_id || '';
            payload.name = formObj?.name || '';
            payload.category_id = formObj?.category_id || '';
            payload.sub_category_id = formObj?.sub_category_id || '';
            // payload.promotion_price = formObj?.promotion_price || '';
            payload.selling_price = formObj?.selling_price || '';
            payload.is_compatible_all = formObj?.compatible === 'fit_all' ? 1 : 0;
            if (formObj?.compatible === 'by_make_model') {
                payload.compatibilities = formObj?.make_model?.length > 0 ?
                    formObj?.make_model?.map(item => {
                        return ({ bike_make_id: item.make, bike_model_ids: item.is_apply_all ? [] : item.model, is_apply_all: item.is_apply_all ? 1 : 0, model: item.model })
                    }
                    ) : [];
            }
        }
        if (currentStep === 2 || currentStep === 5) {
            payload.title = formObj?.title || '';
            payload.description = formObj?.description || '';
            if (formObj?.compatible === 'by_make_model') {
                payload.compatibilities = formObj?.make_model?.length > 0 ?
                    formObj?.make_model?.map(item => {
                        return ({ bike_make_id: item.make, bike_model_ids: item.is_apply_all ? [] : item.model, is_apply_all: item.is_apply_all ? 1 : 0, model: item.model })
                    }
                    ) : [];
            }

        }
        if (currentStep === 3 || currentStep === 5) {
            payload.salesmans = formObj?.salesman?.map((item) => ({
                salesman_id: item?.salesman_id,
                location_id: item?.location_id,
            }));
            if (formObj?.compatible === 'by_make_model') {
                payload.compatibilities = formObj?.make_model?.length > 0 ?
                    formObj?.make_model?.map(item => {
                        return ({ bike_make_id: item.make, bike_model_ids: item.is_apply_all ? [] : item.model, is_apply_all: item.is_apply_all ? 1 : 0, model: item.model })
                    }
                    ) : [];
            }
        }
        if (currentStep === 4 || currentStep === 5) {
            payload.thumbnail = formObj?.photos?.filter((item) => item.is_thumbnail)?.[0]?.file_base64 || '';
            payload.thumbnail_name = formObj?.photos?.filter((item) => item.is_thumbnail)?.[0]?.file_name || '';
            payload.attachments = formObj?.photos?.map((item) => { return ({ path: item?.file_base64, name: item?.file_name }) }) || [];
            payload.youtube_url = formObj?.youtube_url || '';
            payload.facebook_url = formObj?.facebook_url || '';
            payload.instagram_url = formObj?.instagram_url || '';
            payload.tiktok_url = formObj?.tiktok_url || '';
            payload.selling_price = formObj?.selling_price || '';
            if (formObj?.compatible === 'by_make_model') {
                payload.compatibilities = formObj?.make_model?.length > 0 ?
                    formObj?.make_model?.map(item => {
                        return ({ bike_make_id: item.make, bike_model_ids: item.is_apply_all ? [] : item.model, is_apply_all: item.is_apply_all ? 1 : 0, model: item.model })
                    }
                    ) : [];
            }
        }
        if (currentStep === 5) {
            payload.agree_terms = agreement ? 1 : 0;
            if (formObj?.compatible === 'by_make_model') {
                payload.compatibilities = formObj?.make_model?.length > 0 ?
                    formObj?.make_model?.map(item => {
                        return ({ bike_make_id: item.make, bike_model_ids: item.is_apply_all ? [] : item.model, is_apply_all: item.is_apply_all ? 1 : 0, model: item.model })
                    }
                    ) : [];
            }
        }
        dispatch(createAccessory(payload));
    }

    const handleSubmit = (isSaveAsDraft) => {
        setIsLoading(true);
        let payload = {
            step: 'submit',
        }
        payload.brand_id = formObj?.brand_id || '';
        payload.name = formObj?.name || '';
        payload.category_id = formObj?.category_id || '';
        payload.sub_category_id = formObj?.sub_category_id || '';
        // payload.promotion_price = formObj?.promotion_price || '';
        payload.selling_price = formObj?.selling_price || '';
        payload.is_compatible_all = formObj?.compatible === 'fit_all' ? 1 : 0;
        if (formObj?.formObj?.make_model?.length > 0 && formObj?.compatible !== 'fit_all') {
            payload.is_apply_all = formObj?.applied_all || 0;
            payload.bike_make_id = formObj?.make_model?.map(item => item.make);
            payload.bike_model_id = formObj?.make_model?.map(item => item.model);
        }
        payload.title = formObj?.title || '';
        payload.description = formObj?.description || '';
        payload.thumbnail = formObj?.photos?.filter((item) => item.is_thumbnail)?.[0]?.file_base64 || '';
        payload.thumbnail_name = formObj?.photos?.filter((item) => item.is_thumbnail)?.[0]?.file_name || '';
        payload.attachments = formObj?.photos?.map((item) => { return ({ path: item?.file_base64, name: item?.file_name }) }) || [];
        payload.youtube_url = formObj?.youtube_url || '';
        payload.facebook_url = formObj?.facebook_url || '';
        payload.instagram_url = formObj?.instagram_url || '';
        payload.tiktok_url = formObj?.tiktok_url || '';
        payload.agree_terms = agreement ? true : false;
        payload.action = isSaveAsDraft ? "draft" : "published";
        payload.salesmans = formObj?.salesman?.map((item) => ({
            salesman_id: item?.salesman_id,
            location_id: item?.location_id,
        }));

        if (formObj?.compatible === 'by_make_model') {
            payload.compatibilities = formObj?.make_model?.length > 0 ?
                formObj?.make_model?.map(item => {
                    return ({ bike_make_id: item.make, bike_model_ids: item.is_apply_all ? [] : item.model, is_apply_all: item.is_apply_all ? 1 : 0, model: item.model })
                }
                ) : [];
        }
        //submit form
        dispatch(createAccessory(payload));
    }

    return (
        <React.Fragment>
            {
                layoutWidth > 768 &&
                <div style={{ position: 'fixed', zIndex: 9, width: '100%', backgroundColor: 'white', paddingBottom: 10 }}>
                    <div className="d-flex mb-2" style={{ backgroundColor: '#A70000', height: 10, width: `${currentStep / totalPage * 100}%`, transition: 'width 0.5s ease' }}></div>
                    <img src={Logo} alt="Logo" style={{ height: 21, width: 91, objectFit: 'contain' }} />
                </div>
            }
            <div className="page-content" style={{ marginTop: layoutWidth <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading && generalCommonCode?.code !== "success"} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />

                    {
                        // currentStep <= totalPage ?
                        <Box pt={layoutWidth <= 768 ? 2 : 6} pb={6} px={layoutWidth <= 768 ? 2 : 8}>
                            {
                                layoutWidth <= 768 &&
                                <div style={{ width: '100%', color: '#D13536', backgroundColor: '#F5F5F5', marginBottom: 20 }}>
                                    <LinearProgress value={currentStep / totalPage * 100} variant="determinate" color="inherit" style={{ height: 9, borderRadius: 100 }} />
                                </div>
                            }
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <div className="subheader-2">Step {currentStep} of {totalPage}</div>
                                    <Box className="d-flex justify-content-between">
                                        <div className="header-2">{steps[currentStep - 1]?.header}</div>
                                    </Box>
                                </Grid>
                                <Grid item md={12} sm={12} xs={12}>
                                    {
                                        currentStep === 1 &&
                                        <AccessoryInfo
                                            formObj={formObj}
                                            handleFormChange={handleFormObjChange}
                                            brandList={brandList}
                                            categoryList={categoryList}
                                            subCategoryList={subCategoryList}
                                            makeList={makeList}
                                            modelList={modelList}
                                            error={error}
                                        />}
                                    {currentStep === 2 && <AdvertisementInfo formObj={formObj} handleFormChange={handleFormObjChange} error={error} />}
                                    {currentStep === 3 && <AccessoryAssignSalesman formObj={formObj} handleFormChange={handleFormObjChange} layoutWidth={layoutWidth} error={error} salesmanList={salesmanList} locationList={locationList} />}
                                    {currentStep === 4 && <UploadMedia formObj={formObj} handleFormChange={handleFormObjChange} layoutWidth={layoutWidth} error={error} />}
                                    {currentStep === 5 &&
                                        <Review formObj={formObj}
                                            makeList={makeList}
                                            modelList={modelList}
                                            handleFormChange={handleFormObjChange}
                                            brandList={brandList}
                                            categoryList={categoryList}
                                            subCategoryList={subCategoryList}
                                            agreement={agreement}
                                            setAgreement={setAgreement}
                                            salesmanList={salesmanList}
                                            locationList={locationList} />}
                                </Grid>
                            </Grid>
                        </Box>
                        // : <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
                        //     <div className="text-center">
                        //         <div className="header-2">{accessoryAdd?.data?.status === "draft" || draft === true ? "Your listing has been saved as a draft." : "Your listing is now live on the marketplace."}</div>
                        //         <div className="my-3 mb-4">{accessoryAdd?.data?.status === "draft" || draft === true ? "You can continue editing and publish it anytime from Listing." : "You can track views and inquiries under Listing."}</div>
                        //         <CustomButton
                        //             title={'Go to Listing'}
                        //             press={() => navigate('/accessories')}
                        //             padding={20}
                        //         />
                        //     </div>
                        // </div>
                    }
                </Container>
            </div>
            {
                currentStep <= totalPage && <div className="mobile-button-container d-flex justify-content-between">
                    <CustomButton
                        title={'Go Back'}
                        press={() => handleGoBack()}
                        borderStyle={'1px solid #1D1B1B'}
                        backgroundColor={'white'}
                        textColor={'#1D1B1B'}
                        width={layoutWidth <= 768 && '100%'}
                        padding={20}
                        marginRight={layoutWidth <= 768 && 10}
                    />
                    {
                        currentStep === totalPage ?
                            <Stack direction="row" columnGap={1}>
                                <CustomButton
                                    title={'Save Draft'}
                                    press={() => { handleSubmit(true); setDraft(true); }}
                                    padding={20}
                                    backgroundColor={'#F9F9F9'}
                                    textColor={currentStep === totalPage ? !agreement ? "#a8a8a8" : '#808588' : '#808588'}
                                    borderStyle={'1px solid #F9F9F9'}
                                    disabled={currentStep === totalPage ? !agreement : false}

                                // width={layoutWidth <= 768 && '30%'}
                                />
                                <CustomButton
                                    title={'Publish Now'}
                                    press={() => { handleSubmit(); setDraft(false); }}
                                    padding={20}
                                    backgroundColor={currentStep === totalPage ? !agreement ? '#6e6e6e' : '#1D1B1B' : '#1D1B1B'}
                                    disabled={currentStep === totalPage ? !agreement : false}

                                // width={layoutWidth <= 768 && '30%'}
                                />
                            </Stack>
                            :
                            <CustomButton
                                title={`${layoutWidth <= 768 ? 'Next' : `Next: ${steps[currentStep]?.buttonText || 'Publish Now'}`}`}
                                press={() => handleVerifyForm()}
                                padding={20}
                                disabled={currentStep === totalPage ? !agreement : false}
                                backgroundColor={currentStep === totalPage ? !agreement ? '#6e6e6e' : '#1D1B1B' : '#1D1B1B'}
                                width={layoutWidth <= 768 && '100%'}
                            />
                    }

                </div>
            }
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Layout, General, Accessory }) {
    const currentStateId = Login?.verifyAdmin?.user?.data?.profile?.state_id;
    const filteredLocationList = General?.states?.find((state) => state.id === currentStateId)?.cities || [];

    return {
        userData: Login?.verifyAdmin?.user?.data,
        userPermission: Login?.permissionArry,
        leftSideBarType: Layout.leftSideBarType,
        layoutWidth: Layout.currentWidth,
        brandList: General.brand,
        categoryList: General.category,
        subCategoryList: General.sub_category,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        accessoryAdd: Accessory?.accessoryAdd,
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        salesmanList: General.dealer_salesmans,
        locationList: General?.dealer_branches || [],
        generalCommonCode: General.generalCommonCode,
    };
}


export default connect(mapStateToProps)(AddAccessory);
